module.exports = __webpack_public_path__ + "static/media/home-bag.11d9ed84.gif";